import { render, staticRenderFns } from "./Keyboard.vue?vue&type=template&id=6c904601&"
import script from "./Keyboard.vue?vue&type=script&lang=js&"
export * from "./Keyboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andy1229/專案/vue_後端網頁介面參考/研訊/shopstore_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c904601')) {
      api.createRecord('6c904601', component.options)
    } else {
      api.reload('6c904601', component.options)
    }
    module.hot.accept("./Keyboard.vue?vue&type=template&id=6c904601&", function () {
      api.rerender('6c904601', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Charts/Keyboard.vue"
export default component.exports